/* MJ & Moi — kleine scripts: mobiel menu, fotogalerij, sorteren, variantprijs. Werkt ook zonder JS. */
(function () {
  // Mobiel menu
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.getElementById('mobiel-menu');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
      toggle.querySelector('[data-icon-open]').hidden = !open;
      toggle.querySelector('[data-icon-close]').hidden = open;
    });
  }

  // Desktopmenu: open submenu sluiten bij klik ernaast
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.site-nav details[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });

  // Fotogalerij: teller op mobiel, miniaturen op desktop
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-track]');
    var count = g.querySelector('[data-count]');
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-thumb]'));
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    function set(i) {
      if (count) count.textContent = i + 1 + ' / ' + slides.length;
      thumbs.forEach(function (t, j) {
        t.setAttribute('aria-current', String(i === j));
      });
    }
    set(0);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) set(slides.indexOf(e.target));
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (s) {
        io.observe(s);
      });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft });
      });
    });
  });

  // Sorteren in een collectie
  document.querySelectorAll('[data-sort-select]').forEach(function (s) {
    s.addEventListener('change', function () {
      s.form.submit();
    });
  });

  // Prijs bijwerken als een stuk varianten heeft
  var variantSelect = document.querySelector('[data-variant-select]');
  var price = document.querySelector('[data-price]');
  if (variantSelect && price) {
    variantSelect.addEventListener('change', function () {
      var opt = variantSelect.options[variantSelect.selectedIndex];
      if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
    });
  }
})();
